import { Gender } from "constant";

export const generateGender = (gender: Gender) => {
  switch (gender) {
    case Gender.Male:
      return "Ông";

    case Gender.FeMale:
      return "Bà";

    default:
      return "";
  }
};
